import { safeSetItem } from "@/features/chat/multi/history/chat-history";

const SESSION_KEY = "flow-builder-session-id";
const CANVAS_OPEN_KEY = "flow-builder-canvas-open";

/** Clear the active session pointer. Other chats keep streaming. */
export function clearPersistedBuildSession() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(SESSION_KEY);
  } catch {
    // ignore
  }
}

/** Remember last focused session — never throws if storage is full. */
export function persistLastFlowBuilderSessionId(sessionId: string) {
  const id = sessionId.trim();
  if (!id || typeof window === "undefined") return;
  safeSetItem(SESSION_KEY, id);
}

export function readLastFlowBuilderSessionId(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(SESSION_KEY);
  } catch {
    return null;
  }
}

function readCanvasOpenMap(): Record<string, boolean> {
  if (typeof window === "undefined") return {};
  try {
    const parsed = JSON.parse(window.localStorage.getItem(CANVAS_OPEN_KEY) || "{}") as Record<
      string,
      boolean
    >;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

/** Remember whether this chat last showed the workflow canvas. */
export function persistFlowBuilderCanvasOpen(sessionId: string, open: boolean) {
  const id = sessionId.trim();
  if (!id || typeof window === "undefined") return;
  const current = readCanvasOpenMap();
  if (open) current[id] = true;
  else delete current[id];
  safeSetItem(CANVAS_OPEN_KEY, JSON.stringify(current));
}

export function readFlowBuilderCanvasOpen(sessionId?: string | null): boolean {
  const id = sessionId?.trim();
  if (!id) return false;
  return readCanvasOpenMap()[id] === true;
}
